// ----------------------------------------------------------------------

const account = {
  displayName: 'Admin',
  photoURL: '/assets/images/avatars/avatar-user.webp',
};

export default account;
